export const DeleteModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Delete Item',
  description = 'Are you sure you want to delete this item?',
  confirmButtonText = 'Delete',
  isLoading = false,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 flex items-center justify-center z-100 p-4"
      style={{
        background: 'rgba(16, 24, 40, 0.70)',
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
      }}
    >
      <div
        className="p-6 shadow-2xl w-[95%] sm:w-[440px] md:w-[460px] max-w-[95vw]"
        style={{
          background: 'var(--q3-surface-default)',
          borderRadius: '16px',
        }}
      >
        <h3 className="text-base font-semibold mb-4" style={{ color: 'var(--q3-neutral-default)' }}>
          {title}
        </h3>

        <p className="mb-6 text-sm" style={{ color: 'var(--q3-neutral-default)' }}>
          {description}
        </p>

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            style={{
              borderRadius: '360px',
              padding: '8px 20px',
              background: 'transparent',
              color: 'var(--q3-neutral-default)',
              border: '1px solid #D0D5DD',
              cursor: 'pointer',
            }}
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            disabled={isLoading}
            style={{
              borderRadius: '360px',
              padding: '8px 20px',
              background: 'var(--destructive)',
              color: '#fff',
              opacity: isLoading ? 0.6 : 1,
              cursor: isLoading ? 'not-allowed' : 'pointer',
            }}
          >
            {isLoading ? 'Deleting...' : confirmButtonText}
          </button>
        </div>
      </div>
    </div>
  );
};
